import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";

const selectPricesState = (state: RootState) => state.prices;

export const selectPrices = createSelector(
  selectPricesState,
  (pricesState) => pricesState
);
